<template>
  <div>
     <v-dialog v-model="AdddialogClone" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Add {{assetType}}</span>
          </v-card-title>
          <v-card-text>
               <template v-if='assetType === "Computer"'>
                 <ComputerForm v-on:duplicate="snackbar = true;snackbartext='Duplicate Asset Tag'" v-on:closeForm="AdddialogClone = false"/>
               </template>
                  <template v-if='assetType === "Phone"'>
                 <PhoneForm v-on:duplicate="snackbar = true;snackbartext='Duplicate Asset Tag'" v-on:closeForm="AdddialogClone = false"/>
               </template>
                  <template  v-if='assetType === "Monitor"'>
                 <MonitorForm v-on:duplicate="snackbar = true;snackbartext='Duplicate Asset Tag'" v-on:closeForm="AdddialogClone = false" />
               </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="AdddialogClone = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import ComputerForm from './ComputerForm'
import PhoneForm from './PhoneForm'
import MonitorForm from './MonitorForm'
export default {
    components : {
          ComputerForm,
          PhoneForm,
          MonitorForm
    },
    data(){
        return{
        AdddialogClone : true, 
  }
},
    props :{
        assetType : String,
        Adddialog : Boolean
    },
    methods :{
    
    },
        watch : {
                AdddialogClone: function (val) {
            if(val === false){
                  this.$emit('Adddialogclose')
            }
    },
    }
}
</script>
